import * as z from "zod/v4";

export const importKlaviyoProfiles = {
  name: "importKlaviyoProfiles" as const,
  input: z.object({ teamId: z.string(), apiKey: z.string() }),
  output: z.object({ workflowId: z.string().nullable() }),
};
